// DS: i3.45
import React from 'react';
import IconWrap from '../../IconWrap';
const BoostFilled = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M14.418 1.003a.527.527 0 01.58.58l-.472 4.607a.4.4 0 01-.114.241l-3.866 3.893-.773 2.549a.529.529 0 01-.198.277l-2.458 1.752a.53.53 0 01-.647-.028.552.552 0 01-.174-.614c.547-1.524.272-3.08-.627-3.783-1.111-.87-2.464-.932-4.011-.562-.457.11-.849-.412-.558-.826l1.834-2.611a.525.525 0 01.28-.202l2.559-.762 3.87-3.898a.4.4 0 01.24-.116l4.535-.497zm-2.42 4.153a1.13 1.13 0 01-1.125 1.134 1.13 1.13 0 01-1.125-1.134 1.13 1.13 0 011.125-1.133A1.13 1.13 0 0112 5.156z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M1.547 14.558c-.062.129.072.264.2.202l3.266-1.597a.152.152 0 00.04-.243l-1.68-1.692a.15.15 0 00-.24.04l-1.586 3.29z"
    })));
};
BoostFilled.displayName = 'BoostFilled';
export default BoostFilled;

//# sourceMappingURL=BoostFilled.js.map